
export const pages = {
  "about/board": null,
  "about/bylaws": null,
  "about/endorsements": null,
  "about/index": null,
  "about/policy": null,
  "account": null,
  "admin/board": null,
  "admin/bylaws": null,
  "admin/chat-rooms": null,
  "admin/config": null,
  "admin/dues": null,
  "admin/endorsements/candidacy": null,
  "admin/endorsements/candidate-endorsement": null,
  "admin/endorsements/election": null,
  "admin/endorsements/index": null,
  "admin/endorsements/measure": null,
  "admin/endorsements/office-holder": null,
  "admin/endorsements/office-type": null,
  "admin/endorsements/office": null,
  "admin/index": null,
  "admin/meeting-attendance": null,
  "admin/member": null,
  "admin/membership": null,
  "admin/policy": null,
  "blog/index": null,
  "blog/moderate": null,
  "blog/post": null,
  "blog/story": null,
  "calendar/event-details": null,
  "calendar/event-editor": null,
  "calendar/index": null,
  "chat/admin": null,
  "chat/index": null,
  "endorsements/index": null,
  "index": null,
  "issues/index": null,
  "issues/post": null,
  "join": null,
  "login": null,
  "notfound": null,
  "treas/counterparty-list": null,
  "treas/counterparty": null,
  "treas/fec-filing": null,
  "treas/fec-schedule": null,
  "treas/ledger": null,
  "treas/monthly-report": null,
  "treas/pending-ledger": null,
  "treas/pending-transaction": null,
  "treas/reconcile": null,
  "treas/transaction": null,
};

export const getPage = page => {
  switch (page) {
  case "about/board":
    if (pages["about/board"] === null) {
      pages["about/board"] = import("./pages/about/board")
        .then(mod => {
          pages["about/board"] = mod.default;
          return mod.default;
        });
    }
    return pages["about/board"];
  case "about/bylaws":
    if (pages["about/bylaws"] === null) {
      pages["about/bylaws"] = import("./pages/about/bylaws")
        .then(mod => {
          pages["about/bylaws"] = mod.default;
          return mod.default;
        });
    }
    return pages["about/bylaws"];
  case "about/endorsements":
    if (pages["about/endorsements"] === null) {
      pages["about/endorsements"] = import("./pages/about/endorsements")
        .then(mod => {
          pages["about/endorsements"] = mod.default;
          return mod.default;
        });
    }
    return pages["about/endorsements"];
  case "about/index":
    if (pages["about/index"] === null) {
      pages["about/index"] = import("./pages/about/index")
        .then(mod => {
          pages["about/index"] = mod.default;
          return mod.default;
        });
    }
    return pages["about/index"];
  case "about/policy":
    if (pages["about/policy"] === null) {
      pages["about/policy"] = import("./pages/about/policy")
        .then(mod => {
          pages["about/policy"] = mod.default;
          return mod.default;
        });
    }
    return pages["about/policy"];
  case "account":
    if (pages["account"] === null) {
      pages["account"] = import("./pages/account")
        .then(mod => {
          pages["account"] = mod.default;
          return mod.default;
        });
    }
    return pages["account"];
  case "admin/board":
    if (pages["admin/board"] === null) {
      pages["admin/board"] = import("./pages/admin/board")
        .then(mod => {
          pages["admin/board"] = mod.default;
          return mod.default;
        });
    }
    return pages["admin/board"];
  case "admin/bylaws":
    if (pages["admin/bylaws"] === null) {
      pages["admin/bylaws"] = import("./pages/admin/bylaws")
        .then(mod => {
          pages["admin/bylaws"] = mod.default;
          return mod.default;
        });
    }
    return pages["admin/bylaws"];
  case "admin/chat-rooms":
    if (pages["admin/chat-rooms"] === null) {
      pages["admin/chat-rooms"] = import("./pages/admin/chat-rooms")
        .then(mod => {
          pages["admin/chat-rooms"] = mod.default;
          return mod.default;
        });
    }
    return pages["admin/chat-rooms"];
  case "admin/config":
    if (pages["admin/config"] === null) {
      pages["admin/config"] = import("./pages/admin/config")
        .then(mod => {
          pages["admin/config"] = mod.default;
          return mod.default;
        });
    }
    return pages["admin/config"];
  case "admin/dues":
    if (pages["admin/dues"] === null) {
      pages["admin/dues"] = import("./pages/admin/dues")
        .then(mod => {
          pages["admin/dues"] = mod.default;
          return mod.default;
        });
    }
    return pages["admin/dues"];
  case "admin/endorsements/candidacy":
    if (pages["admin/endorsements/candidacy"] === null) {
      pages["admin/endorsements/candidacy"] = import("./pages/admin/endorsements/candidacy")
        .then(mod => {
          pages["admin/endorsements/candidacy"] = mod.default;
          return mod.default;
        });
    }
    return pages["admin/endorsements/candidacy"];
  case "admin/endorsements/candidate-endorsement":
    if (pages["admin/endorsements/candidate-endorsement"] === null) {
      pages["admin/endorsements/candidate-endorsement"] = import("./pages/admin/endorsements/candidate-endorsement")
        .then(mod => {
          pages["admin/endorsements/candidate-endorsement"] = mod.default;
          return mod.default;
        });
    }
    return pages["admin/endorsements/candidate-endorsement"];
  case "admin/endorsements/election":
    if (pages["admin/endorsements/election"] === null) {
      pages["admin/endorsements/election"] = import("./pages/admin/endorsements/election")
        .then(mod => {
          pages["admin/endorsements/election"] = mod.default;
          return mod.default;
        });
    }
    return pages["admin/endorsements/election"];
  case "admin/endorsements/index":
    if (pages["admin/endorsements/index"] === null) {
      pages["admin/endorsements/index"] = import("./pages/admin/endorsements/index")
        .then(mod => {
          pages["admin/endorsements/index"] = mod.default;
          return mod.default;
        });
    }
    return pages["admin/endorsements/index"];
  case "admin/endorsements/measure":
    if (pages["admin/endorsements/measure"] === null) {
      pages["admin/endorsements/measure"] = import("./pages/admin/endorsements/measure")
        .then(mod => {
          pages["admin/endorsements/measure"] = mod.default;
          return mod.default;
        });
    }
    return pages["admin/endorsements/measure"];
  case "admin/endorsements/office-holder":
    if (pages["admin/endorsements/office-holder"] === null) {
      pages["admin/endorsements/office-holder"] = import("./pages/admin/endorsements/office-holder")
        .then(mod => {
          pages["admin/endorsements/office-holder"] = mod.default;
          return mod.default;
        });
    }
    return pages["admin/endorsements/office-holder"];
  case "admin/endorsements/office-type":
    if (pages["admin/endorsements/office-type"] === null) {
      pages["admin/endorsements/office-type"] = import("./pages/admin/endorsements/office-type")
        .then(mod => {
          pages["admin/endorsements/office-type"] = mod.default;
          return mod.default;
        });
    }
    return pages["admin/endorsements/office-type"];
  case "admin/endorsements/office":
    if (pages["admin/endorsements/office"] === null) {
      pages["admin/endorsements/office"] = import("./pages/admin/endorsements/office")
        .then(mod => {
          pages["admin/endorsements/office"] = mod.default;
          return mod.default;
        });
    }
    return pages["admin/endorsements/office"];
  case "admin/index":
    if (pages["admin/index"] === null) {
      pages["admin/index"] = import("./pages/admin/index")
        .then(mod => {
          pages["admin/index"] = mod.default;
          return mod.default;
        });
    }
    return pages["admin/index"];
  case "admin/meeting-attendance":
    if (pages["admin/meeting-attendance"] === null) {
      pages["admin/meeting-attendance"] = import("./pages/admin/meeting-attendance")
        .then(mod => {
          pages["admin/meeting-attendance"] = mod.default;
          return mod.default;
        });
    }
    return pages["admin/meeting-attendance"];
  case "admin/member":
    if (pages["admin/member"] === null) {
      pages["admin/member"] = import("./pages/admin/member")
        .then(mod => {
          pages["admin/member"] = mod.default;
          return mod.default;
        });
    }
    return pages["admin/member"];
  case "admin/membership":
    if (pages["admin/membership"] === null) {
      pages["admin/membership"] = import("./pages/admin/membership")
        .then(mod => {
          pages["admin/membership"] = mod.default;
          return mod.default;
        });
    }
    return pages["admin/membership"];
  case "admin/policy":
    if (pages["admin/policy"] === null) {
      pages["admin/policy"] = import("./pages/admin/policy")
        .then(mod => {
          pages["admin/policy"] = mod.default;
          return mod.default;
        });
    }
    return pages["admin/policy"];
  case "blog/index":
    if (pages["blog/index"] === null) {
      pages["blog/index"] = import("./pages/blog/index")
        .then(mod => {
          pages["blog/index"] = mod.default;
          return mod.default;
        });
    }
    return pages["blog/index"];
  case "blog/moderate":
    if (pages["blog/moderate"] === null) {
      pages["blog/moderate"] = import("./pages/blog/moderate")
        .then(mod => {
          pages["blog/moderate"] = mod.default;
          return mod.default;
        });
    }
    return pages["blog/moderate"];
  case "blog/post":
    if (pages["blog/post"] === null) {
      pages["blog/post"] = import("./pages/blog/post")
        .then(mod => {
          pages["blog/post"] = mod.default;
          return mod.default;
        });
    }
    return pages["blog/post"];
  case "blog/story":
    if (pages["blog/story"] === null) {
      pages["blog/story"] = import("./pages/blog/story")
        .then(mod => {
          pages["blog/story"] = mod.default;
          return mod.default;
        });
    }
    return pages["blog/story"];
  case "calendar/event-details":
    if (pages["calendar/event-details"] === null) {
      pages["calendar/event-details"] = import("./pages/calendar/event-details")
        .then(mod => {
          pages["calendar/event-details"] = mod.default;
          return mod.default;
        });
    }
    return pages["calendar/event-details"];
  case "calendar/event-editor":
    if (pages["calendar/event-editor"] === null) {
      pages["calendar/event-editor"] = import("./pages/calendar/event-editor")
        .then(mod => {
          pages["calendar/event-editor"] = mod.default;
          return mod.default;
        });
    }
    return pages["calendar/event-editor"];
  case "calendar/index":
    if (pages["calendar/index"] === null) {
      pages["calendar/index"] = import("./pages/calendar/index")
        .then(mod => {
          pages["calendar/index"] = mod.default;
          return mod.default;
        });
    }
    return pages["calendar/index"];
  case "chat/admin":
    if (pages["chat/admin"] === null) {
      pages["chat/admin"] = import("./pages/chat/admin")
        .then(mod => {
          pages["chat/admin"] = mod.default;
          return mod.default;
        });
    }
    return pages["chat/admin"];
  case "chat/index":
    if (pages["chat/index"] === null) {
      pages["chat/index"] = import("./pages/chat/index")
        .then(mod => {
          pages["chat/index"] = mod.default;
          return mod.default;
        });
    }
    return pages["chat/index"];
  case "endorsements/index":
    if (pages["endorsements/index"] === null) {
      pages["endorsements/index"] = import("./pages/endorsements/index")
        .then(mod => {
          pages["endorsements/index"] = mod.default;
          return mod.default;
        });
    }
    return pages["endorsements/index"];
  case "index":
    if (pages["index"] === null) {
      pages["index"] = import("./pages/index")
        .then(mod => {
          pages["index"] = mod.default;
          return mod.default;
        });
    }
    return pages["index"];
  case "issues/index":
    if (pages["issues/index"] === null) {
      pages["issues/index"] = import("./pages/issues/index")
        .then(mod => {
          pages["issues/index"] = mod.default;
          return mod.default;
        });
    }
    return pages["issues/index"];
  case "issues/post":
    if (pages["issues/post"] === null) {
      pages["issues/post"] = import("./pages/issues/post")
        .then(mod => {
          pages["issues/post"] = mod.default;
          return mod.default;
        });
    }
    return pages["issues/post"];
  case "join":
    if (pages["join"] === null) {
      pages["join"] = import("./pages/join")
        .then(mod => {
          pages["join"] = mod.default;
          return mod.default;
        });
    }
    return pages["join"];
  case "login":
    if (pages["login"] === null) {
      pages["login"] = import("./pages/login")
        .then(mod => {
          pages["login"] = mod.default;
          return mod.default;
        });
    }
    return pages["login"];
  case "notfound":
    if (pages["notfound"] === null) {
      pages["notfound"] = import("./pages/notfound")
        .then(mod => {
          pages["notfound"] = mod.default;
          return mod.default;
        });
    }
    return pages["notfound"];
  case "treas/counterparty-list":
    if (pages["treas/counterparty-list"] === null) {
      pages["treas/counterparty-list"] = import("./pages/treas/counterparty-list")
        .then(mod => {
          pages["treas/counterparty-list"] = mod.default;
          return mod.default;
        });
    }
    return pages["treas/counterparty-list"];
  case "treas/counterparty":
    if (pages["treas/counterparty"] === null) {
      pages["treas/counterparty"] = import("./pages/treas/counterparty")
        .then(mod => {
          pages["treas/counterparty"] = mod.default;
          return mod.default;
        });
    }
    return pages["treas/counterparty"];
  case "treas/fec-filing":
    if (pages["treas/fec-filing"] === null) {
      pages["treas/fec-filing"] = import("./pages/treas/fec-filing")
        .then(mod => {
          pages["treas/fec-filing"] = mod.default;
          return mod.default;
        });
    }
    return pages["treas/fec-filing"];
  case "treas/fec-schedule":
    if (pages["treas/fec-schedule"] === null) {
      pages["treas/fec-schedule"] = import("./pages/treas/fec-schedule")
        .then(mod => {
          pages["treas/fec-schedule"] = mod.default;
          return mod.default;
        });
    }
    return pages["treas/fec-schedule"];
  case "treas/ledger":
    if (pages["treas/ledger"] === null) {
      pages["treas/ledger"] = import("./pages/treas/ledger")
        .then(mod => {
          pages["treas/ledger"] = mod.default;
          return mod.default;
        });
    }
    return pages["treas/ledger"];
  case "treas/monthly-report":
    if (pages["treas/monthly-report"] === null) {
      pages["treas/monthly-report"] = import("./pages/treas/monthly-report")
        .then(mod => {
          pages["treas/monthly-report"] = mod.default;
          return mod.default;
        });
    }
    return pages["treas/monthly-report"];
  case "treas/pending-ledger":
    if (pages["treas/pending-ledger"] === null) {
      pages["treas/pending-ledger"] = import("./pages/treas/pending-ledger")
        .then(mod => {
          pages["treas/pending-ledger"] = mod.default;
          return mod.default;
        });
    }
    return pages["treas/pending-ledger"];
  case "treas/pending-transaction":
    if (pages["treas/pending-transaction"] === null) {
      pages["treas/pending-transaction"] = import("./pages/treas/pending-transaction")
        .then(mod => {
          pages["treas/pending-transaction"] = mod.default;
          return mod.default;
        });
    }
    return pages["treas/pending-transaction"];
  case "treas/reconcile":
    if (pages["treas/reconcile"] === null) {
      pages["treas/reconcile"] = import("./pages/treas/reconcile")
        .then(mod => {
          pages["treas/reconcile"] = mod.default;
          return mod.default;
        });
    }
    return pages["treas/reconcile"];
  case "treas/transaction":
    if (pages["treas/transaction"] === null) {
      pages["treas/transaction"] = import("./pages/treas/transaction")
        .then(mod => {
          pages["treas/transaction"] = mod.default;
          return mod.default;
        });
    }
    return pages["treas/transaction"];
  default:
    return null;
  }
};
